module.exports = __webpack_public_path__ + "static/img/chat-logo.b47c8ced.svg";